module.exports = __webpack_public_path__ + "images/tinkoff-2384d0e4.png";